var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThailand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40.0001C31.0455 40.0001 39.9998 31.0458 39.9998 20.0001C39.9998 8.95443 31.0455 0.00012207 19.9998 0.00012207C8.95414 0.00012207 -0.000167847 8.95443 -0.000167847 20.0001C-0.000167847 31.0458 8.95414 40.0001 19.9998 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.756 13.0436H1.24397C0.439985 15.2102 -1.52588e-05 17.5537 -1.52588e-05 20.0001C-1.52588e-05 22.4465 0.439985 24.7899 1.24397 26.9565H38.7561C39.56 24.7899 40 22.4465 40 20.0001C40 17.5537 39.56 15.2102 38.756 13.0436Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.00012207C13.9382 0.00012207 8.50674 2.69731 4.839 6.95661H35.1609C31.4933 2.69731 26.0618 0.00012207 20 0.00012207V0.00012207Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.161 33.0436H4.839C8.50674 37.3029 13.9382 40.0001 20 40.0001C26.0618 40.0001 31.4933 37.3029 35.161 33.0436Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThailand);
export default __webpack_public_path__ + "static/media/thailand.2c84727204d9ada57e00e252d2df18f4.svg";
export { ForwardRef as ReactComponent };